<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">リードVCの重要性
</h1>	

                <span class="meta"> Posted in January 2023 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/break-from-the-sheep.jpg" alt="">
                </figure>
                
<p>企業の創業者にとって、リード VC からのコミットメントを得ることは資金調達のプロセスにおいて、間違いなく最も重要なマイルストーンである。リード VC はコミットメントをすることでリスクを負うことになる。これにより、ほかの投資家は安心して共同出資を行うことができ、タイムリーなクロージングが可能になる。特に企業の初期段階では不確実性が最も高く、創業者のベンチャーに対するビジョンが最もクレイジーに見えるため、リードVCが必要となる。</p>
<p>私はさまざまな地域（アメリカ、ヨーロッパ、日本）でアーリーステージのベンチャー投資を行ってきたが、日本がこの現象を最もよく表していると思う。日本ではプレシード、シードそしてシリーズAの段階で投資をしてくれるベンチャーキャピタルファンドの数が、野心的なプロジェクトを持つ有能な起業家の供給に対してあまりにも不足している。</p>
<p>更に、アーリーステージ投資に前向きな限られた VC ファンドの中でさえ、自ら進んでディールをリードしてくれるところはほとんどいないのが現状だ。「リードが見つかったらまた来てください」というフレーズは「シリーズへの準備ができたらまた来てください」という決まり文句に似た、あまりにもよく言われる言葉だ。</p>
<p>リードVCとは？</p>
<p>新興のスタートアップのエコシステムでは、リード VC の定義が曖昧なことがよくある。 そのため、ここではリード VC とは何か、自分なりの解釈を紹介する。</p>
<p>資金調達ラウンドにおけるリード VC とは、そのスタートアップに投資することを最初に確約するVCファンドのことだ。リード VC は、書面でそのコミットメントを表明し、提案する投資の条件と評価額を明示する。</p>
<p>創業者との合意が成立すると、リード VC は 資金調達ラウンドを構成し、契約締結とクロージングのスケジュールを設定する。また、通常投資案件のデューディリジェンスの大部分をリード VC が行う。リード VC は必ずしも投資ラウンドで最大の小切手を出すわけではないが、そのコミットメント体制により資金調達プロセスを活性化させる役割を担う。</p>
<p>なぜリードVCになることを怯えるのか？</p>
<p>スタートアップへの投資希望者にとって、様子見のアプローチを取ることは非常に魅力的なことだ。投資家は、自分たちの意思決定プロセスを裏付けるデータを集めるのが大好きだ。VC の経営者は、自分のファンドの投資家に対して受託者責任を負っており、投資候補先に対して充分なデューディリジェンスを行う義務がある。</p>
<p>不完全な情報で意思決定を行うことは、本質的に不安なものである。歴の長い企業のなかでは特にこのような間違いが許されない風潮が見かけられる。不確実性を受け入れることができるようになるには時間がかかる。他人の資金を投資する場合にはなおさらだ。そのため新しいベンチャーキャピタルや CVC がアーリーステージの企業への投資決定を実質的な検証が行われるまで延期するのは、理解できることである。</p>
<p>しかし、このことは二つの異なる目標を生み出す。創業者は資金調達ラウンドをできるだけ早く終了させ自社のビジネス構築という中核的な使命に戻りたいと考えている。一方、投資家は更なる検証を待ちたいと考えている。</p>
<p>「将来またラウンドが決まったら検討します」や「リード VC が見つかったらまた話しましょう」といったフレーズは投資家が更なる検証を待っている典型的な症状だ。しかし、ベンチャー投資は情報が不完全な中でディールを行う、という信念がなければ成功はありえないと私たちは考えている。</p>
<p>とは言え、リードするのではなくフォローすることを戦略としているVCファンドには本質的な問題はない。CVC のように企業シナジーを狙って投資するファンドの中には、独立系のVCファンドに条件や評価を決めてもらうことを好むこともある。また、単純にフォローした方が居心地がよく、LP にもその理解を得ているファンドもある。リード VC になるには単にシンジケートのフォロワーとして参加するよりもはるかに多くの努力が必要だ。</p>
<p>透明性がカギとなる</p>
<p>VC 投資家におけるリードまたはフォロワーの性質はわかりづらく、また、誤解を招くようなマーケティングによりさらに難解になることが多い。したがって創業者が最初の話し合いで投資家に尋ねる 最善の質問 の一つは次のようなものだと私は考えている。</p>
<p>あなたのファンドは通常、新規投資においてリード VC として機能していますか、それともフォロワーとして機能しますか。</p>
<p>あるいは、</p>
<p>あなたのファンドから投資の見込みを得た場合、あなたはリード VC の役割を果たしますか、それともフォローすることを望みますか。</p>



              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>

